import React from 'react';
import { Box, Typography, Paper, Stack, IconButton } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

const SupportPage = () => {
    return (
        <div className="support-container">
        {/* Text Section */}
        <div className="support-content">
          <h1>Support and Help</h1>
          <p>
            Need assistance? We're here to help. Contact us anytime, and we'll be
            happy to assist you with your queries or issues.
          </p>
          <div className="contact-details">
            <p><strong>Phone:</strong> +91 85218 68842</p>
            <p><strong>Email:</strong> randkpvtlimted@gmail.com</p>
          </div>
          {/* <button className="learn-more-btn">Learn More</button> */}
        </div>
        
        {/* Image Section */}
        <div className="support-image">
          <img
            src="https://krisp.ai/blog/wp-content/uploads/2022/01/how-we-hire.png"
            alt="Support Help"
          />
        </div>
      </div>
  

        // <Box
        //     sx={{
        //         display: 'flex',
        //         justifyContent: 'center',
        //         alignItems: 'center',
        //         height: '100vh',
        //         backgroundColor: '#f5f5f5',
        //     }}
        // >
        //     <Paper
        //         elevation={4}
        //         sx={{
        //             padding: '40px',
        //             borderRadius: '12px',
        //             backgroundColor: '#ffffff',
        //             maxWidth: '400px',
        //             textAlign: 'center',
        //         }}
        //     >
        //         <Typography
        //             variant="h4"
        //             gutterBottom
        //             sx={{ fontWeight: 'bold', color: '#1976d2' }}
        //         >
        //             Support
        //         </Typography>
        //         <Typography variant="body1" color="textSecondary" mb={3}>
        //             Need help? Reach out to us!
        //         </Typography>

        //         <Stack spacing={2} alignItems="center">
        //             <Box sx={{ display: 'flex', alignItems: 'center' }}>
        //                 <IconButton color="primary">
        //                     <PhoneIcon />
        //                 </IconButton>
        //                 <Typography variant="body1" sx={{ marginLeft: '8px' }}>
        //                     +91 85218 68842
        //                 </Typography>
        //             </Box>

        //             <Box sx={{ display: 'flex', alignItems: 'center' }}>
        //                 <IconButton color="primary">
        //                     <EmailIcon />
        //                 </IconButton>
        //                 <Typography variant="body1" sx={{ marginLeft: '8px' }}>
        //                 randkpvtlimted@gmail.com
        //                 </Typography>
        //             </Box>
        //         </Stack>
        //     </Paper>
        // </Box>
    );
};

export default SupportPage;
